import { render, staticRenderFns } from "./SongEditCommon.vue?vue&type=template&id=2f0248ba&"
import script from "./SongEditCommon.vue?vue&type=script&lang=js&"
export * from "./SongEditCommon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/eric/projects/musical/musical-admin-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f0248ba')) {
      api.createRecord('2f0248ba', component.options)
    } else {
      api.reload('2f0248ba', component.options)
    }
    module.hot.accept("./SongEditCommon.vue?vue&type=template&id=2f0248ba&", function () {
      api.rerender('2f0248ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SongEditCommon.vue"
export default component.exports